<template>
    <div class="alert-box">
        <!--弹窗组件-->
        <el-dialog
            :visible.sync="show"
            :width="width"
            :append-to-body="true"
            :lock-scroll="true"
            :before-close="close"
            :close-on-click-modal="false"
            :title="title">
            <div class="wrapper" v-if="show" :style="{maxHeight: parseInt(winHeight * 0.65) + 'px'}">
                <slot></slot>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AlertBox",
        props: {
            show: {
                type: Boolean,
                default: false
            },
            width: {
                type: String,
                default: '60%'
            },
            title: {
                type: String,
                default: '弹窗'
            }
        },
        data() {
            return {
                winHeight: window.innerHeight,
            };
        },
        methods: {
            //关闭窗口的触发事件
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
.wrapper {
    overflow-y: auto;
}
</style>